import { Button, Layout, theme, Form, Spin, notification } from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import TextArea from "antd/es/input/TextArea";
import CompliantApi from "../../common/Apis/CompliantApi";

const CreateComplains = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      customerCompliant: data.compliant,
      compliantTo: "admin@admin.com",
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    CompliantApi.CreateCompliant(formData)
      .then((response) => {
        setLoadings(false);
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/complaints");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16} className="pt-3">
                <Col span={16}>
                  <Form.Item
                    name="compliant"
                    label="Corrective Action / Maintenance Issue *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Corrective Action / Maintenance Issue.",
                      },
                    ]}
                  >
                    <TextArea
                      className="form-control control-input p-3"
                      rows={5}
                      style={{ resize: "none" }}
                    ></TextArea>
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default CreateComplains;
